@if (
    !displayNoSigBoxes
    || (
        signature1?.isFinalized 
        && displayOneSigBox
    ) 
    || (
        signature1?.isFinalized 
        && signature2?.isFinalized
    )
    || (
        oosOnComingStr != null 
        && !oosIsOffGoing
    ) 
    || (
        oosOffGoingStr != null 
        && oosIsOffGoing
    )
) {
    <div class="row">
        <div class="col-md-6 verify-1">
            @if (
                !isSig2() 
                && !isPin2() 
                && !isNuv2() 
                && !isOos2()
            ) {
                <label class="control-label for text-center">{{ getTitle(1) }}</label>
                @if (
                    signature1?.isFinalized
                    || signature1?.userId !== null
                ) {
                    <div class="row">
                        <div class="col-md-12">
                            {{ signature1.userName }} {{ signature1?.timeStamp | date: 'M/d, h:mm a' }}
                            @if (signature1?.isPin) {
                                <img 
                                    src="/assets/images/icons/pin.svg" 
                                    class="fingerprint svg-inversion" 
                                    ngbTooltip="Verified with PIN Authentication" 
                                    alt=""
                                />    
                            }
                            @if (signature1?.verificationType === 0) {
                                <fa-icon 
                                    [icon]="faIcon.faFileSignature" 
                                    class="fa-size" 
                                    alt="Verified with Signature Authentication" 
                                    ngbTooltip="Verified with Signature Authentication"
                                ></fa-icon>
                            }
                            @if (signature1?.verificationType === 4) {
                                <fa-icon 
                                    [icon]="faIcon.faUserNurse" 
                                    class="fa-size" 
                                    alt="Verified with Non-User Signature Authentication" 
                                    ngbTooltip="Verified with Non-User Signature Authentication"
                                ></fa-icon>	
                            }                
                            <br />
                            @if (signature1?.isFinalized) {
                                @if (signature1?.signatureBase64 !== '') {
                                    <img 
                                        [src]="'data:image/png;base64,' + signature1?.signatureBase64" 
                                        [ngClass]="{ hidden: !signature1?.isFinalized }" 
                                        class="imageExists svg-inversion" 
                                        id="imgOncoming" 
                                        alt=""
                                    />
                                } @else if (signature1?.signaturePath !== '') {
                                    <img 
                                        [src]="signature1?.signaturePath" 
                                        [ngClass]="{ hidden: !signature1?.isFinalized }" 
                                        class="imageExists svg-inversion" 
                                        id="imgOncoming" 
                                        alt=""
                                    />
                                }
                            }
                        </div>
                    </div>
                }
                @if (
                    oosOnComingStr != null 
                    && !oosIsOffGoing
                ) {
                    <div>
                        {{ oosOnComingStr}}
                        {{ oosTimeStamp | date: 'M/dd, h:mm a'  }}
                        <fa-icon 
                            [icon]="faIcon.faHouseMedicalCircleXmark" 
                            class="fa-size"
                            [alt]="'Verified with ' + clientOutOfServiceName + ' Location Feature'" 
                            [ngbTooltip]="'Verified with ' + clientOutOfServiceName + ' Location Feature'"
                        ></fa-icon>
                        <br/>
                        <span class="oos-stamp">{{ clientOutOfServiceName }}</span>
                    </div>            
                }
                <!--
                    S2N-1420 (5c): canSignFirst gates THIS position only. Slot 2 further down is
                    left alone -- on a medication use it is the designated witness position, and
                    filling it is the one write a Witness came here to make.
                -->
                @if (
                    !isSig1()
                    && !isPin1()
                    && !isNuv1()
                    && !isSig2()
                    && !isPin2()
                    && !isNuv2()
                    && !signature1?.isFinalized
                    && !isOos1()
                    && !isOos2()
                    && oosOnComingStr == null
                    && !isViewOnly
                    && canSignFirst
                    && padIsAvailable(1)
                ) {
                    <div class="row">
                        <div class="col-md-12 div-buttons">
                            @if (
                                !signature1?.isFinalized
                                && displayPin
                            ) {
                                <div>
                                    <button 
                                        type="button" 
                                        class="btn pin-btn" 
                                        (click)="pinClick(1)"
                                    >
                                        <img 
                                            src="/assets/images/icons/pin.svg" 
                                            class="icon-img" 
                                            alt=""
                                        />
                                        <span class="pin-btn-web">PIN</span>	
                                    </button>
                                </div>
                            }
                            @if (
                                !signature1?.isFinalized 
                                && displaySignature
                            ) {
                                <div>
                                    <button 
                                        type="button" 
                                        class="btn sig-btn" 
                                        (click)="sigClick(1)"
                                    >
                                        <fa-icon 
                                            [icon]="faIcon.faFileSignature" 
                                            class="icon-size"
                                        ></fa-icon>
                                        <span class="sig-btn-web">Signature</span>
                                    </button>
                                </div>
                            }
                            @if (
                                !signature1?.isFinalized 
                                && displayNuv 
                                && showNuv1()
                            ) {
                                <div>
                                    <button 
                                        type="button" 
                                        class="btn sig-btn" 
                                        (click)="nuvClick(1)"
                                    >
                                        <fa-icon 
                                            [icon]="faIcon.faUserNurse" 
                                            class="icon-size"
                                        ></fa-icon>
                                        <br />
                                        <span class="sig-btn-web">{{ nuvString }}</span>
                                    </button>
                                </div>
                            }
                            @if (
                                !signature1?.isFinalized 
                                && displayOos 
                                && showOos1()
                            ) {
                                <div>
                                    <button 
                                        type="button" 
                                        class="btn sig-btn" 
                                        (click)="oosClick(1)"
                                    >
                                        <fa-icon 
                                            [icon]="faIcon.faHouseMedicalCircleXmark" 
                                            class="icon-size"
                                        ></fa-icon>
                                        <br/>
                                        <span class="sig-btn-web">{{ clientOutOfServiceName }}</span>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                } @else if (
                    (
                        isViewOnly
                        || !canSignFirst
                    )
                    && !signature1?.isFinalized
                    && oosOnComingStr == null
                ) {
                    <!--
                        S2N-3076: View Only reads who signed but is offered no verification input.
                        S2N-1420 (5c): a Witness reads the same thing here -- the position is the
                        administering user's, so say it is empty rather than render an empty card.
                    -->
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <small class="text-muted"><i>Not yet verified</i></small>
                        </div>
                    </div>
                }

                <div class="row">
                    <div class="col-md-12">
                        <!-- #region Signature 1 Row -->
                        @if (isSig1()) {
                            <button 
                                class="btn btn-cancel btn-lg" 
                                (click)="cancelSig(1)"
                            >Cancel</button>
                            <span>&nbsp;</span>
                            <button 
                                type="submit" 
                                class="btn btn-save btn-lg" 
                                (click)="validateSig(1)"
                            >Confirm</button>                            
                        } 
                        <div 
                            #container1 
                            [ngClass]="{noCanvasContainer: !isSig1(), canvasContainer: isSig1()}"
                            class="svg-inversion"
                        >
                            <canvas 
                                #canvas1 
                                id="signaturePad1"
                            ></canvas>
                        </div>
                        <!-- #endregion -->
        
                        <!-- #region NUV 1 Row -->
                        @if (isNuv1()) { 
                            @if (mobileNuvInput1()) {
                                <div>
                                    <label 
                                        for="nuv1" 
                                        class="required-field for"
                                    >Enter {{ nuvString }} Name:</label>
                                </div>
                                <input 
                                    #txtNonUserName1 
                                    type="text" 
                                    class="form-control nuv-text"
                                    [class]="isNuv1NameInvalid() ? 'border border-danger' : ''"
                                    placeholder="Type your name" 
                                    maxlength="257" 
                                    [(ngModel)]="nonUserName1"
                                    required
                                    (keyup)="validateNurseVerificationName($event, 1)"
                                    (keydown.enter)="
                                        $event.preventDefault(); 
                                        mobileNuvInput(1)
                                    "
                                />
                                <button 
                                    type="button" 
                                    class="btn btn-save btn-sm mt-1" 
                                    [class]="isMobile() ? '' : 'ml-1'"
                                    (click)="mobileNuvInput(1)"
                                >Next</button>
                                @if (isNuv1NameInvalid()) { <div class="text-danger">Maximum length is 256</div> }
                            } @else {
                                <div class="signLabel">
                                    <label 
                                        for="sig1" 
                                        class="required-field for"
                                    >Sign Below:</label>
                                </div>
                            }                                                   
                        }
                        <div 
                            #nuvContainer1 
                            [ngClass]="
                                {
                                    noNuvCanvasContainer: (!isNuv1() || mobileNuvInput1())
                                    , nuvCanvasContainer: (isNuv1() && !mobileNuvInput1())
                                }
                            "
                            class="svg-inversion"
                        >
                            <canvas 
                                #nuvCanvas1 
                                id="nuvSignaturePad1"
                            ></canvas>
                        </div>  
                        @if (isNuv1()) {
                            <div class="nurseSignOffBtn"> 
                                <button 
                                    class="btn btn-cancel btn-lg" 
                                    (click)="cancelNuvSig(1)"
                                >Cancel</button>
                                <span>&nbsp;</span>
                                @if (!mobileNuvInput1()) {
                                    <button 
                                        type="submit" 
                                        class="btn btn-save btn-lg" 
                                        (click)="validateNuvSig(1)"
                                    >Confirm</button>
                                    <span>&nbsp;</span>
                                }                                                             
                            </div>
                        }
                        <!--#endregion-->
                    </div>
                </div>

                <!--#region Pin 1-->
                @if (isPin1()) {
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <label 
                                        for="pin1" 
                                        class="required-field for"
                                    >Enter PIN</label>
                                    <input
                                        #txtPin1
                                        (keydown.enter)="validatePin(1)"
                                        [(ngModel)]="pin1"
                                        required
                                        id="pin1"
                                        type="password"
                                        autocomplete="one-time-code" 
                                        pcgNumeric
                                        inputmode="numeric"
                                        class="form-control pin-input"
                                        maxlength="10"
                                        name="password"
                                    />
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-12">
                                    <a 
                                        class="btn btn-cancel btn-lg" 
                                        (click)="cancelPin(1)"
                                    >Cancel</a>
                                    &nbsp;
                                    <button 
                                        tabindex="0" 
                                        type="submit" 
                                        class="btn btn-save btn-lg" 
                                        (click)="validatePin(1)"
                                    >Confirm</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <!--#endregion-->
                
                <!--#region OOS 1-->
                @if (isOos1()) {
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <label 
                                        for="oos1" 
                                        class="required-field for"
                                    >{{ clientOutOfServiceName }} Locations</label>
                                    <pcg-select 
                                        placeholder="Select a Location" 
                                        [multiple]="false" 
                                        [(ngModel)]="oosId"
                                        [dataSource]="'api/Select/OutOfServiceLocations?clientId=' + clientId" 
                                        (itemLoad)="getOosSelectItems($event)"
                                        [selectFirstValue]="true"
                                    ></pcg-select>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-md-12">
                                    <a 
                                        class="btn btn-cancel btn-lg" 
                                        (click)="cancelOos(1)"
                                    >Cancel</a>
                                    &nbsp;
                                    <button 
                                        tabindex="0" 
                                        type="submit" 
                                        class="btn btn-save btn-lg" 
                                        (click)="validateOos(1)"
                                    >Confirm</button> 
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <!--#endregion-->
            }
        </div>        

        @if (
            (
                !displayOneSigBox
                || signature2?.isFinalized
            ) && (
                signature2?.timeStamp == null
                || signature1?.timeStamp !== signature2?.timeStamp
            )
        ) {
            <div class="col-md-6 verify-2">
                @if(
                    !isSig1() 
                    && !isPin1() 
                    && !isNuv1() 
                    && !isOos1()
                ) {
                    @if (
                        isMobile() 
                        && (
                            isSig1() 
                            || isNuv1()
                        )
                    ) { <div><br /><br /></div> }
                    <div class="d-xl-flex">
                        @if (
                            requireVerificationsInOrder 
                            && !signature1?.isFinalized
                        ) { <label class="control-label for text-center"><i>*Complete {{getTitle(1)}}</i></label> } 
                        @else { <label class="control-label for text-center">{{ getTitle(2) }}</label> }
                    </div>

                    @if (
                        signature2?.isFinalized 
                        || signature2?.userId !== null
                    ) {
                        <div class="row">
                            <div class="col-md-12">
                                {{ signature2.userName }} {{ signature2?.timeStamp | date: 'M/dd, h:mm a' }}
                                @if (signature2?.isPin) {
                                    <img 
                                        src="/assets/images/icons/pin.svg" 
                                        class="fingerprint svg-inversion" 
                                        ngbTooltip="Verified with PIN Authentication" 
                                        alt=""
                                    />
                                }
                                @if (signature2?.verificationType === 0) {
                                    <fa-icon 
                                        [icon]="faIcon.faFileSignature" 
                                        class="fa-size" 
                                        alt="Verified with Signature Authentication" 
                                        ngbTooltip="Verified with Signature Authentication"
                                    ></fa-icon>	
                                }
                                @if (signature2?.verificationType === 4) {
                                    <fa-icon 
                                        [icon]="faIcon.faUserNurse" 
                                        class="fa-size" 
                                        alt="Verified with Non-User Signature Authentication" 
                                        ngbTooltip="Verified with Non-User Signature Authentication"
                                    ></fa-icon>	
                                }                            
                                <br />
                                @if (signature2?.isFinalized) {
                                    @if (signature2?.signatureBase64 !== '') {
                                        <img 
                                            [src]="'data:image/png;base64,' + signature2?.signatureBase64" 
                                            [ngClass]="{ hidden: !signature2?.isFinalized }" 
                                            class="imageExists svg-inversion" 
                                            id="imgOffgoing" 
                                            alt=""
                                        />
                                    } @else if (signature2?.signaturePath !== '') {
                                        <img 
                                            [src]="signature2?.signaturePath" 
                                            [ngClass]="{ hidden: !signature2?.isFinalized }" 
                                            class="imageExists svg-inversion" 
                                            id="imgOffgoing" 
                                            alt=""
                                        />
                                    }
                                }
                            </div>
                        </div>
                    }
                    
                    @if (
                        oosOffGoingStr != null 
                        && oosIsOffGoing
                    ) {
                        <div>
                            {{ oosOffGoingStr }}
                            {{ oosTimeStamp | date: 'M/dd, h:mm a'  }}
                            <fa-icon 
                                [icon]="faIcon.faHouseMedicalCircleXmark" 
                                class="fa-size"
                                [alt]="'Verified with ' + clientOutOfServiceName + ' Location Feature'" 
                                [ngbTooltip]="'Verified with ' + clientOutOfServiceName + ' Location Feature'"
                            ></fa-icon>	
                            <br/>
                            <span class="oos-stamp">{{ clientOutOfServiceName }}</span>
                        </div>
                    }

                    @if (
                        !isSig1() 
                        && !isPin1() 
                        && !isNuv1() 
                        && !isOos1()
                        && !isSig2() 
                        && !isPin2() 
                        && !isNuv2() 
                        && !isOos2()
                        && !signature2?.isFinalized
                        && oosOffGoingStr == null
                        && !isViewOnly
                        && padIsAvailable(2)
                    ) {
                        <div class="row">
                            <div 
                                class="col-md-12 div-buttons"
                                [class]="requireVerificationsInOrder && !signature1?.isFinalized ? 'greyed-out' : ''"
                            >
                                @if (
                                    !signature2?.isFinalized 
                                    && displayPin
                                ) {
                                    <div>
                                        <button 
                                            type="button" 
                                            [class]="requireVerificationsInOrder && !signature1?.isFinalized ? 'pin-btn-no-hover' : 'btn pin-btn'" 
                                            [disabled]="requireVerificationsInOrder && !signature1?.isFinalized"
                                            (click)="pinClick(2)"
                                        >
                                            <img 
                                                src="/assets/images/icons/pin.svg" 
                                                class="icon-img"
                                                alt=""
                                            />
                                            <span class="pin-btn-web">PIN</span>	
                                        </button>
                                    </div>
                                }
                                @if (
                                    !signature2?.isFinalized 
                                    && displaySignature
                                ) {
                                    <div>
                                        <button 
                                            type="button" 
                                            [class]="requireVerificationsInOrder && !signature1?.isFinalized ? 'sig-btn-no-hover' : 'btn sig-btn'"
                                            [disabled]="requireVerificationsInOrder && !signature1?.isFinalized"
                                            (click)="sigClick(2)"
                                        >
                                            <fa-icon 
                                                [icon]="faIcon.faFileSignature" 
                                                class="icon-size"
                                            ></fa-icon>
                                            <span class="sig-btn-web">Signature</span>
                                        </button>
                                    </div>
                                }
                                @if (
                                    !signature2?.isFinalized 
                                    && displayNuv 
                                    && showNuv2()
                                ) {
                                    <div>
                                        <button 
                                            type="button" 
                                            class="btn sig-btn" 
                                            (click)="nuvClick(2)"
                                        >
                                            <fa-icon 
                                                [icon]="faIcon.faUserNurse" 
                                                class="icon-size"
                                            ></fa-icon>
                                            <br />
                                            <span class="sig-btn-web">{{ nuvString }}</span> 
                                        </button>
                                    </div>
                                }
                                @if (
                                    !signature2?.isFinalized 
                                    && displayOos 
                                    && showOos2()
                                ) {
                                    <div>
                                        <button 
                                            type="button" 
                                            class="btn sig-btn" 
                                            (click)="oosClick(2)"
                                        >
                                            <fa-icon 
                                                [icon]="faIcon.faHouseMedicalCircleXmark" 
                                                class="icon-size"
                                            ></fa-icon>
                                            <br/>
                                            <span class="sig-btn-web">{{ clientOutOfServiceName }}</span>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    } @else if (
                        isViewOnly
                        && !signature2?.isFinalized
                        && oosOffGoingStr == null
                    ) {
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <small class="text-muted"><i>Not yet verified</i></small>
                            </div>
                        </div>
                    }
                    
                    <div class="row">
                        <div class="col-md-12">
                            <!--#region Signature 2 Row-->
                            @if (isSig2()) {
                                <button 
                                    class="btn btn-cancel btn-lg" 
                                    (click)="cancelSig(2)"
                                > Cancel</button>
                                <span>&nbsp;</span>
                                <button 
                                    type="submit" 
                                    class="btn btn-save btn-lg" 
                                    (click)="validateSig(2)"
                                >Confirm</button>
                            } 
                            <div 
                                #container2 
                                [ngClass]="{noCanvasContainer: !isSig2(), canvasContainer: isSig2()}"
                                class="svg-inversion"
                            >
                                <canvas 
                                    #canvas2 
                                    id="signaturePad2"
                                ></canvas>
                            </div>
                            <!--#endregion-->

                            <!--#region NUV 2 Row-->
                            @if (isNuv2()) {                                
                                @if (mobileNuvInput2()) {
                                    <div>
                                        <label 
                                            for="nuv2" 
                                            class="required-field for nameLabel"
                                        >Enter {{ nuvString }} Name:</label>
                                    </div>
                                    <input 
                                        #txtNonUserName2 
                                        type="text" 
                                        class="form-control nuv-text" 
                                        [class]="isNuv2NameInvalid() ? 'border border-danger' : ''"
                                        placeholder="Type your name" 
                                        maxlength="257" 
                                        [(ngModel)]="nonUserName2" 
                                        (keyup)="validateNurseVerificationName($event, 2)"
                                        (keydown.enter)="
                                            $event.preventDefault(); 
                                            mobileNuvInput(2)
                                        "
                                    />
                                    <button 
                                        type="button" 
                                        class="btn btn-save btn-sm mt-1" 
                                        [class]="isMobile() ? '' : 'ml-1'"
                                        (click)="mobileNuvInput(2)"
                                    >Next</button>
                                    @if (isNuv2NameInvalid()) { <div class="text-danger">Maximum length is 256</div> }
                                } @else {
                                    <div class="signLabel">
                                        <label 
                                            for="sig2" 
                                            class="required-field for"
                                        >Sign Below:</label>
                                    </div>
                                }
                            }
                            <div 
                                #nuvContainer2 
                                [ngClass]="
                                    {
                                        noNuvCanvasContainer: (!isNuv2() || mobileNuvInput2())
                                        , nuvCanvasContainer: (isNuv2() && !mobileNuvInput2())
                                    }
                                "
                                class="svg-inversion"
                            >
                                <canvas 
                                    #nuvCanvas2 
                                    id="nuvSignaturePad2" 
                                    required
                                ></canvas>
                            </div>
                            @if (isNuv2()) {                            
                                <div class="nurseSignOffBtn">
                                    <button 
                                        class="btn btn-cancel btn-lg" 
                                        (click)="cancelNuvSig(2)"
                                    >Cancel</button>
                                    <span>&nbsp;</span>
                                    @if (!mobileNuvInput2()) {
                                        <button 
                                            type="submit" 
                                            class="btn btn-save btn-lg" 
                                            (click)="validateNuvSig(2)"
                                        >Confirm</button>
                                        <span>&nbsp;</span>
                                    }
                                </div>
                            }
                            <!--#endregion-->
                        </div>
                    </div>

                    <!--#region Pin 2-->
                    @if (isPin2()) {
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label 
                                            for="pin2" 
                                            class="required-field for"
                                        >Enter PIN</label>
                                        <input
                                            #txtPin2
                                            (keydown.enter)="validatePin(2)"
                                            [(ngModel)]="pin2"
                                            required
                                            id="pin2"
                                            type="password"
                                            autocomplete="one-time-code" 
                                            pcgNumeric
                                            inputmode="numeric"
                                            class="form-control pin-input"
                                            maxlength="10"
                                            name="password"
                                        />
                                    </div>
                                </div>
                                <br />

                                <div class="row">
                                    <div class="col-md-12">
                                        <a 
                                            class="btn btn-cancel btn-lg" 
                                            (click)="cancelPin(2)"
                                        >Cancel</a>
                                        &nbsp;
                                        <button 
                                            tabindex="0" 
                                            type="submit" 
                                            class="btn btn-save btn-lg" 
                                            (click)="validatePin(2)"
                                        >Confirm</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <!--#endregion-->
                    
                    <!--#region OOS 2-->
                    @if (isOos2()) {
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label 
                                            for="oos2" 
                                            class="required-field for"
                                        >{{ clientOutOfServiceName }} Locations</label>
                                        <pcg-select 
                                            placeholder="Select a Location"
                                            [multiple]="false" 
                                            [(ngModel)]="oosId"
                                            [dataSource]="'api/Select/OutOfServiceLocations?clientId=' + clientId" 
                                            (itemLoad)="getOosSelectItems($event)"
                                        ></pcg-select>
                                    </div>
                                </div>
                                <br />

                                <div class="row">
                                    <div class="col-md-12">
                                        <a 
                                            class="btn btn-cancel btn-lg" 
                                            (click)="cancelOos(2)"
                                        >Cancel</a>
                                        &nbsp;
                                        <button 
                                            tabindex="0" 
                                            type="submit" 
                                            class="btn btn-save btn-lg" 
                                            (click)="validateOos(2)"
                                        >Confirm</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <!--#endregion-->
                }             
            </div>
        }        
    </div>
}